import { React, useRef } from 'react';
import styled from 'styled-components';

export default function YoutubeVideoURLInput(props) {
  const { index, value, setValue, onPressEnter } = props;

  const InputRef = useRef();

  function handleChange(e) {
		setValue(e.target.value, index);
	}

	function handleFocus(e) {
    
	}

	function handleBlur(e) {

	}

  function onKeyUp(e) {
    if (e.keyCode === 13) onPressEnter(index);
  }

  return (
    <TopLevelWrapper>
      <Input
        ref={InputRef}
        type='text'
        placeholder='https://www.youtube.com/watch?v='
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyUp={onKeyUp} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  background-color: transparent;
`;

const Input = styled.input`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #595959;
  
  border: 0px;

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  outline: none;

  ::placeholder {
    color: #BDBDBD;
  }

  background-color: transparent;
  transition: all 0.3s ease-in-out;
`;